$(document).click(function(e) { 

	let institutionDropdown = '.dropdown__switch',
		accountDropdown = '.dropdown__account',
		coPaymentList = '.payment__list li',
        filterDropdown = '.filter-dropdown ul';

    if(!$(e.target).closest(institutionDropdown).length) {
        if($(institutionDropdown).hasClass("active")) {
            $(institutionDropdown).removeClass("active");
        }
    }   

    if(!$(e.target).closest(accountDropdown).length) {
        if($(accountDropdown).hasClass("active")) {
            $(accountDropdown).removeClass("active");
        }
    }  

    if(!$(e.target).closest(filterDropdown).length) {

        if(!$(e.target).closest('.filter-dropdown').length) {

            $(filterDropdown).removeClass("expande");
        }
    }   

})